import { Autocomplete } from "@react-google-maps/api";
import { useRef } from "react";
import { useUserLocation } from "../providers/LocationProvider";
import { useGoogleMaps } from "../context/GoogleMapsProvider";

const LocationInput = ({ formData, setFormData }) => {
  const { setLocation } = useUserLocation();

  // ✅ Get Google loading state
  const { isLoaded, loadError } = useGoogleMaps();

  const autoRef = useRef(null);

  const onLoad = (autocomplete) => {
    autoRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (!autoRef.current) return;

    const place = autoRef.current.getPlace();

    if (!place?.geometry) return;

    setFormData((prev) => ({
      ...prev,
      location: {
        address: place.formatted_address,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        placeId: place.place_id,
      },
    }));

    setLocation({
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    });
  };

  const options = {
    componentRestrictions: {
      country: "ng",
    },
  };

  // ✅ Handle loading error
  if (loadError) {
    return (
      <div className="form-group">
        <label>Location or Training Center Address</label>

        <input
          type="text"
          placeholder="Google Maps failed to load"
          className="tutor-input-field"
          disabled
        />
      </div>
    );
  }

  // ✅ Prevent rendering before Google loads
  if (!isLoaded) {
    return (
      <div className="form-group">
        <label>Location or Training Center Address</label>
        <input
          type="text"
          placeholder="Loading location services..."
          className="tutor-input-field"
          disabled
        />
      </div>
    );
  }

  return (
    <div className="form-group">
      <label>Location or Training Center Address</label>

      <Autocomplete
        onLoad={onLoad}
        onPlaceChanged={onPlaceChanged}
        options={options}
      >
        <input
          type="text"
          placeholder="Enter your location"
          defaultValue={formData.location?.address || ""}
          className="tutor-input-field"
        />
      </Autocomplete>
    </div>
  );
};

export default LocationInput;